import React from "react";
import { useSelector } from "react-redux";
import { getConventionsSelector } from "../../../../../../store/conventionsSlice";
import { Select } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Select convention.
 */
export const SelectConvention = (props) => {
  // COMPONENT STATE ----------------------------------------------------------

  const conventions = useSelector(getConventionsSelector);
  let options = [
    {
      value: "",
      label: "",
    },
  ];

  // DYNAMIC CONSTANTS --------------------------------------------------------

  if (Array.isArray(conventions)) {
    options = options.concat(
      conventions.map(({ name }) => ({ value: name, label: name }))
    );
  }

  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "select-convention-error",
  };

  const selectProps = {
    id: "select-convention",
    className: "form-control small",
    "aria-describedby": errorProps.id,
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: selectProps.id,
    children: "CONVENTION ID",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    selectProps,
    labelProps,
    errorProps,
    options,
    fieldName: FORM_KEYS.CNAME,
  };

  return <Select {...parentProps} />;
};
